import React, { useEffect, useState } from 'react';
import { publicAPI } from '../services/api';
import { Wrench } from 'lucide-react';

export const MaintenancePage = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    publicAPI.getLanding().then((r) => setCfg(r.data)).catch(() => {});
    const t = setInterval(() => {
      publicAPI.getLanding().then((r) => {
        if (!r.data?.maintenance?.enabled) {
          window.location.href = '/';
        } else {
          setCfg(r.data);
        }
      }).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, []);

  const brand = cfg?.brand?.name || 'Matrise Wallet';
  const message = cfg?.maintenance?.message || "We're doing some quick maintenance. Please check back shortly.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-foreground px-4" data-testid="maintenance-page">
      <div className="max-w-md w-full text-center">
        <div className="h-16 w-16 rounded-full bg-amber-500/15 text-amber-500 flex items-center justify-center mx-auto mb-6">
          <Wrench className="h-8 w-8" />
        </div>
        <h1 className="text-3xl font-semibold mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>{brand} is under maintenance</h1>
        <p className="text-muted-foreground whitespace-pre-wrap">{message}</p>
        <p className="text-xs text-muted-foreground mt-6">This page refreshes automatically when we&apos;re back.</p>
      </div>
    </div>
  );
};

export default MaintenancePage;
